<template>
  <v-app>
    <EPSHeader />
    <router-view></router-view>
    <br />
    <br />
    <EPSFooter />
  </v-app>
</template>

<script>
import EPSHeader from "./components/EPSHeader";
import EPSFooter from "./components/EPSFooter";

export default {
  components: {
    EPSHeader,
    EPSFooter,
  },
};
</script>
